<template>
  <v-app id="vuetify-app">
    <v-container fluid>
      <v-layout align-center justify-center row fill-height>
        <v-flex xs12 md4>
          <v-card>
            <v-card-title>
              <h3>
                {{ `app.login_to_system` | trans }}
              </h3>
            </v-card-title>
            <v-card-text>
              <v-alert :value="true" type="success">
                {{ `app.mobile_app.login.patient_user_exists` | trans }}
              </v-alert>
              <v-form>
                <v-text-field
                    v-model="email"
                    readonly
                    disabled
                    :label="`app.email` | trans "
                ></v-text-field>
                <v-text-field
                    v-model="password"
                    type="password"
                    required
                    :label="`app.password` | trans"
                ></v-text-field>
                <v-btn :disabled="loading" :loading="loading" color="primary" type="submit"
                       @click="loginPatient">{{ `app.mobile_app.login.login` | trans }}
                </v-btn>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <a :href="routes.reset_password">{{ `app.forgot_password` | trans }}</a>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>
<script>
import {trans} from "../../app";

export default {
  props: {
    email: String,
    routes: Object,
  },
  data() {
    return {
      loading: false,
      password: "",
    };
  },
  methods: {
    loginPatient() {
      this.loading = true;
      axios.post(this.routes.login, {
        email: this.email,
        password: this.password,
      }).then((response) => {
        window.location.href = response.data.redirect;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$toast.error(trans('app.mobile_app.login.login_failed'));
      })
    }
  }
}
</script>
